import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { apiClient } from '../../../lib/api/client';
import type { Dayjs } from 'dayjs';

dayjs.extend(utc);

export function defaultDailyTrackingDateRange(): [Dayjs, Dayjs] {
  const end = dayjs().utc().endOf('day');
  const start = end.subtract(29, 'day').startOf('day');
  return [start, end];
}

export interface DailyTaskTrackingRow {
  date: string;
  totalTasks: number;
  completedTasks: number;
  inProgressTasks: number;
  overdueTasks: number;
  blockedTasks: number;
  cancelledTasks: number;
  completionRate: number;
}

export interface DailyTaskTrackingSummary {
  totalTasks: number;
  completedTasks: number;
  inProgressTasks: number;
  overdueTasks: number;
  blockedTasks: number;
  cancelledTasks: number;
  completionRate: number;
}

export interface DailyTaskTrackingResponse {
  summary: DailyTaskTrackingSummary;
  dailyRows: DailyTaskTrackingRow[];
}

export interface GetDailyTaskTrackingParams {
  fromUtc?: string;
  toUtc?: string;
  segmentIds?: string[];
  contactCategoryIds?: number[];
  assigneeIds?: string[];
}

export async function getDailyTaskTracking(
  params?: GetDailyTaskTrackingParams
): Promise<DailyTaskTrackingResponse> {
  const searchParams = new URLSearchParams();
  if (params?.fromUtc) searchParams.set('fromUtc', params.fromUtc);
  if (params?.toUtc) searchParams.set('toUtc', params.toUtc);
  if (params?.segmentIds?.length) {
    for (const id of params.segmentIds) searchParams.append('segmentIds', id);
  }
  if (params?.contactCategoryIds?.length) {
    for (const id of params.contactCategoryIds) searchParams.append('contactCategoryIds', String(id));
  }
  if (params?.assigneeIds?.length) {
    for (const id of params.assigneeIds) searchParams.append('assigneeIds', id);
  }
  const response = await apiClient.get<DailyTaskTrackingResponse>(
    `/dashboard/daily-task-tracking?${searchParams.toString()}`
  );
  return response.data;
}

export async function exportDailyTaskTrackingPdf(
  params?: GetDailyTaskTrackingParams
): Promise<Blob> {
  const searchParams = new URLSearchParams();
  if (params?.fromUtc) searchParams.set('fromUtc', params.fromUtc);
  if (params?.toUtc) searchParams.set('toUtc', params.toUtc);
  if (params?.segmentIds?.length) {
    for (const id of params.segmentIds) searchParams.append('segmentIds', id);
  }
  if (params?.contactCategoryIds?.length) {
    for (const id of params.contactCategoryIds) searchParams.append('contactCategoryIds', String(id));
  }
  if (params?.assigneeIds?.length) {
    for (const id of params.assigneeIds) searchParams.append('assigneeIds', id);
  }
  const response = await apiClient.get<Blob>(
    `/dashboard/daily-task-tracking/export/pdf?${searchParams.toString()}`,
    { responseType: 'blob' }
  );
  return response.data;
}
